import { createSlice } from '@reduxjs/toolkit'

import { doQuote, doQuotePriceSelected } from 'pu-utils/quoteServicesApi';

import { ERROR, PRICE_SELECTED, QUOTED } from 'pu-data/QuoteSteps';

import DefaultState, { validateParametersRules, aditionalRules } from './DefaultState';
import InitialState from './InitialState'
import { scrollToAssembly, updateProjectNumber, addProjectErrors } from '../../project_quote/data/ProjectSlice';

const assemblyService = createSlice({
  name: 'assemblyService',
  initialState: InitialState,

  reducers: {
    changeParameter(state, action) {
      const { name, value } = action.payload
      switch (name) {
        case 'qty1':
          state.parameters.quantities[0] = value
          break;
        case 'qty2':
          state.parameters.quantities[1] = value
          break;
        case 'qty3':
          state.parameters.quantities[2] = value
          break;
        case 'qty4':
          state.parameters.quantities[3] = value
          break;
        default:
          state.parameters[name] = value
      }
      if (name !== 'part_number' && name !== 'revision') {
        state.parametersChanged = true
      }
    },
    quoteStart(state) {
      state.loading = true
    },
    quoteSuccess(state, action) {
      state.quote = action.payload
      state.loading = false
      state.parameters.product_quote_number = state.quote.number
      delete state.parameters.row_selected
      delete state.parameters.column_selected
      delete state.parameters.supplier_selected
      state.quoteStep = QUOTED
      state.itemSelected = false
      state.parametersChanged = false

      if (!state.firstQuoteMade) {
        state.firstQuoteMade = state.quote.number
      }
    },
    quoteFailure(state) {
      state.loading = false
      state.quote = {}
      state.itemSelected = false
      state.quoteStep = ERROR
    },
    setPriceSelected(state, action) {
      const { row_selected, column_selected, supplier } = action.payload
      state.parameters.row_selected = row_selected
      state.parameters.column_selected = column_selected
      state.parameters.supplier_selected = supplier
      state.showSummary = true
      state.itemSelected = true
      state.quoteStep = PRICE_SELECTED
      state.currentVariant = state.assemblyVariants[supplier];
    },
    updateParametersFromBOM(state, action) {
      const { parameters } = action.payload
      Object.keys(parameters).forEach((prm) => {
        state.parameters[prm] = parameters[prm]
      })
    },
    formValidated(state, action) {
      state.errors = action.payload
    },
    allowEdit(state) {
      state.showSummary = false
    },
    deleteQuote(state) {
      Object.assign(state, DefaultState)
    },
  },
});

export const {
  changeParameter,
  quoteStart,
  quoteSuccess,
  quoteFailure,
  setPriceSelected,
  updateParametersFromBOM,
  formValidated,
  allowEdit,
  deleteQuote,
} = assemblyService.actions

export default assemblyService.reducer

const validateParameters = (parameters) => {
  const errors = {}
  Object.keys(parameters).forEach((key) => {
    if (!validateParametersRules[key]) return;
    const newError = validateParametersRules[key](parameters[key]);
    if (newError) {
      errors[key] = newError
    }
  });

  Object.entries(aditionalRules).forEach(([key, rule]) => {
    const newError = rule(parameters);
    if (newError) {
      errors[key] = newError
    }
  });

  return errors
}

export const fetchQuote = (suppliers, parameters, authToken, variantId) => async (dispatch) => {
  try {
    const options = {};
    suppliers.forEach((s) => {
      options[s] = parameters
    })

    const errors = validateParameters(parameters)
    if (errors && Object.keys(errors).length) {
      dispatch(formValidated(errors))
      scrollToAssembly()
      return;
    }

    dispatch(formValidated({}))
    dispatch(quoteStart())

    const bundle_number = document.getElementById('bundle_number').value;
    const bundle_variant_id = document.getElementById('variant_id').value;
    const response = await doQuote(
      options,
      authToken,
      variantId,
      parameters.quote_number,
      bundle_number,
      bundle_variant_id,
    );
    dispatch(quoteSuccess(response))

    document.getElementsByName('bundle_number')[0].value = response.bundle_id
    dispatch(updateProjectNumber(response))
  } catch (err) {
    console.error(err.toString())
    dispatch(quoteFailure(err.toString()))
    dispatch(addProjectErrors('The site could not get a quote for the Assembly Service, please try again later.'))
  }
}

export const priceSelected = (data, authToken, number) => async (dispatch) => {
  try {
    dispatch(setPriceSelected(data))
    await doQuotePriceSelected(data, authToken, number)
  } catch (err) {
    // error
  }
}
